import { UserType } from "@clovis/server/src/app/config/segment/types";
import * as React from "react";
import { useNavigate } from "react-router";
import { useSegment } from "~/config/segment/SegmentProvider";
import { useUser } from "~/config/user/UserProvider";
import { createComponentHook } from "~/types";
import { UnavailableStateView } from "./UnavailableStateView";

const useUnavailableScreen = createComponentHook(() => {
  const navigate = useNavigate();
  const { user } = useUser();
  const SegmentAnalyticsContext = useSegment();

  React.useEffect(() => {
    // Unavailable page should be accessible only if the user is locked
    if (!user.is_locked) {
      navigate("/", { replace: true });
    }
  }, [navigate, user.is_locked]);

  React.useEffect(() => {
    if (SegmentAnalyticsContext) {
      // Track the event on Segment
      void SegmentAnalyticsContext.track({
        event: "Unavailable",
        properties: {
          organizationName: user.active_org?.org.name ?? "",
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          userEmail: user.contact!.email!,
          userType: user.active_org ? UserType.MEMBER : UserType.PARTICIPANT,
        },
        type: "track",
        userId: user.id,
      });
    }
  }, [SegmentAnalyticsContext, user]);

  return {
    state: {
      user,
    },
  };
});

function UnavailableScreen() {
  const { state } = useUnavailableScreen();

  return (
    <UnavailableStateView
      email={state.user?.contact?.email ?? undefined}
      variant="locked"
    />
  );
}

export { UnavailableScreen };
